import React from 'react';
import { autobind } from 'core-decorators';
import View from './view';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

@autobind
class FaixaMinMaxIndex extends React.Component {
  render() {
    return <View {...this.props} />;
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
  };
}

export default injectIntl(connect(mapStateToProps)(FaixaMinMaxIndex));
